module.exports = __webpack_public_path__ + "img/VP-Profi13_Overview-Rear_1.1478c7bb.jpg";